import request from "@/utils/request";

export function getGroups() {
  return request({
    url: "/home/group/list",
    method: "get"
  });
}
